<div class="info" *ngIf="showBannerNotification || showBannerInvoice">
    <div>
        <mat-icon>info_outlined</mat-icon>
        <p *ngIf="showBannerNotification" class="text-info-container">{{keyTranslate + '.notificationBanner' | translate}}
        </p>
        <p *ngIf="showBannerInvoice" class="text-info-container">{{keyTranslate + '.invoiceBanner' | translate}}</p>
    </div>
    <button *ngIf="showBannerNotification" [disabled]="disableButton" class="resendButton"
        (click)="emitOnClick()">
        Reenviar</button>
</div>